import { EUROPEAN_BRANDS_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { useMemo } from "react";
export var useLayoutElementsQueryKey = function() {
    var categoryModel = useCurrentCategoryModel();
    var isEuropeanBrandsCategory = categoryModel.urlId.id === EUROPEAN_BRANDS_URL_ID;
    var _categoryModel_mostSpecificPathIdentifier;
    var pathIdentifier = (_categoryModel_mostSpecificPathIdentifier = categoryModel.mostSpecificPathIdentifier) !== null && _categoryModel_mostSpecificPathIdentifier !== void 0 ? _categoryModel_mostSpecificPathIdentifier : categoryModel.mostSpecificName;
    return useMemo(function() {
        return [
            "CategoryPageLayoutElements",
            pathIdentifier,
            isEuropeanBrandsCategory
        ];
    }, [
        isEuropeanBrandsCategory,
        pathIdentifier
    ]);
};
